<template>
    <v-col cols="12" sm="6" md="4" lg="3" xl="3">
        <v-card>
            <v-toolbar flat dense color="grey lighten-4">
                <v-container class="pa-0">
                    <v-row justify="space-between" dense align="center">
                        <v-col cols="auto">
                            <v-toolbar-title>
                                {{ widget.body.title }}
                            </v-toolbar-title>
                        </v-col>
                        <v-col cols="auto">
                            <v-tooltip :open-delay="tooltipDelay" top>
                                <template #activator="{on}">
                                    <v-btn
                                        color="green"
                                        icon
                                        small
                                        data-sentry-label="Dashboard; zamówienia do wysyłki - Generuj raport"
                                        v-on="on"
                                        @click="generateOrdersProductsNotSentReport()"
                                    >
                                        <v-icon>mdi-file-excel</v-icon>
                                    </v-btn>
                                </template>
                                <span>Eksportuj</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-container>
            </v-toolbar>
            <v-divider />
            <v-card-text>
                <v-container class="pa-0">
                    <OrdersProductsPerDayNotSentListDialog
                        :is-open="ordersProductsPerDayNotSentListDialog"
                        :date="currentDate"
                        :partner="partner"
                        :orders-products-per-day-not-sent="ordersProducts"
                        @close-not-sent-orders-products-dialog="closeOrdersProductsPerDayNotSentListDialog"
                    />

                    <v-row>
                        <v-col class="pa-0" cols="12">
                            <v-btn
                                text
                                icon
                                color="blue-grey"
                                data-sentry-label="Poprzedni dzień"
                                :disabled="disableBackward"
                                @click="previousDay()"
                            >
                                <v-icon>
                                    mdi-chevron-left
                                </v-icon>
                            </v-btn>
                            <span class="text-subtitle-2">
                                {{ currentDateFormatted }}
                            </span>
                            <v-btn
                                text
                                icon
                                color="blue-grey"
                                data-sentry-label="Następny dzień"
                                :disabled="disableForward"
                                @click="nextDay()"
                            >
                                <v-icon>
                                    mdi-chevron-right
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
                <v-data-table
                    :headers="headers"
                    :items="orderedOrders"
                    :mobile-breakpoint="0"
                    dense
                    hide-default-footer
                >
                    <template #item="{item}">
                        <tr>
                            <td>
                                {{ item.orderLocation }}
                            </td>
                            <td>
                                {{ item.toSend }}
                            </td>
                            <td class="text-right">
                                <div class="d-inline-flex">
                                    <v-tooltip :open-delay="tooltipDelay" top>
                                        <template #activator="{on}">
                                            <v-btn 
                                                v-if="item.orderLocation"
                                                icon
                                                data-sentry-label="Wyswietl szczegóły"
                                                v-on="on"
                                                @click="showOrdersProductsPerDayNotSentListDialog(item)"
                                            >
                                                <v-icon color="blue">
                                                    mdi-ballot
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Wyświetl szczegóły</span>
                                    </v-tooltip>
                                </div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
import store from '@/store'
import dateFormatter from '@/mixins/dateFormatter'
import { isSameDay, addDays, subDays } from 'date-fns'
import tooltipDelay from '@/mixins/tooltip'
import OrdersProductsPerDayNotSentListDialog from './OrdersProductsPerDayNotSentListDialog'
import { errorHandler } from '@/utils/errorHandler'
import pagination from '@/mixins/dataTablePagination'

export default {
    name: 'OrdersPerDayNotSentReport',
    components: {
        OrdersProductsPerDayNotSentListDialog
    },
    mixins: [
        dateFormatter,
        tooltipDelay,
        pagination
    ],
    props: {
        widget: {
            type: Object,
            default: null
        },
        permissions: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            headers: [
                {
                    text: 'Nazwa',
                    value: 'orderLocation',
                    sortable: false,
                },
                {
                    text: 'Ilość',
                    value: 'toSend',
                    sortable: false,
                },
                {
                    text: 'Szczegóły',
                    value: 'details',
                    sortable: false,
                    align: 'right',
                },
            ],
            currentDate: null,
            currentDateFormatted: null,
            sources: [],
            targetDay: 1,
            todaysOrdersNotSent: [],
            ordersProducts: [],
            partner: '',
            actionLoading: {
                ordersProductsPerDayNotSent: false
            },
            ordersProductsPerDayNotSentListDialog: false,
            user: {},
        }
    },
    computed: {
        disableForward() {
            return this.targetDay === 7
        },
        disableBackward() {
            return this.targetDay === 1
        },
        ordersProductsPerDayNotSent() {
            return this.$store.state.dashboard.ordersProductsPerDayNotSent
        },
        orderedOrders() {
            return this.orderTodaysOrders()
        },
        userId() {
            return this.$store.state.user.userId
        }
    },
    mounted() {
        this.$store.dispatch('administration/getUser', this.userId )
            .then(response => {
                this.user = response.data
            })
            .catch(error => {
                errorHandler(error)
            })
    },
    created() {
        this.setDate()
        this.todaysOrders()
    },
    methods: {
        previousDay() {
            this.targetDay--
            let nextDay = subDays(new Date(this.currentDate), 1)

            this.currentDateFormatted = this.formatDate(new Date(nextDay), false)
            this.currentDate = nextDay
            this.todaysOrders()
        },
        nextDay() {
            this.targetDay++
            let previousDay = addDays(new Date(this.currentDate), 1)

            this.currentDateFormatted = this.formatDate(new Date(previousDay), false)
            this.currentDate = previousDay
            this.todaysOrders()
        },
        setDate() {
            this.currentDateFormatted = this.formatDate(new Date(), false)
            this.currentDate = new Date()

        },
        todaysOrders() {
            this.todaysOrdersNotSent = []
            this.widget.body.content.forEach(element => {
                if (isSameDay(new Date(element.checkDate), new Date(this.currentDate))) {
                    this.todaysOrdersNotSent.push(element)
                }
            })
        },
        orderTodaysOrders() {
            const selectedOrder = {'Drukomat' : 1, 'WMD': 2, 'Czeskie': 3, 'Offline': 4, null: 5}

            const sortedOrders = this.todaysOrdersNotSent.sort((a, b) => selectedOrder[a.orderLocation] - selectedOrder[b.orderLocation])

            return sortedOrders
        },
        closeOrdersProductsPerDayNotSentListDialog() {
            this.ordersProductsPerDayNotSentListDialog = false
            setTimeout(() => {
                this.ordersProducts = []
            }, 500)
        },
        showOrdersProductsPerDayNotSentListDialog(item) {
            this.pagination.itemsPerPage = 10
            this.pagination.page = 1
            this.actionLoading.ordersProductsPerDayNotSent = true
            this.partner = item.orderLocation
            this.$store.dispatch('dashboard/getOrdersProductsPerDayNotSent', {
                query: `?dueDate=${item.checkDate}&partner=${this.partner}`
            })
                .then(response => {
                    this.ordersProducts = response.data.results
                    this.ordersProductsPerDayNotSentListDialog = true
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.ordersProductsPerDayNotSent = false
                })
        },
        generateOrdersProductsNotSentReport() {
            store.dispatch('toggleMainLoader', true)
            this.$store.dispatch('dashboard/generateOrdersProductsPerDayNotSentReport', {
                userEmail: this.user.email,
                query: `&dueDate=${this.currentDateFormatted}`
            })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    store.dispatch('toggleMainLoader', false)
                })
        },
    }
}
</script>
